import common from './common';
import s3 from './s3';
import ec2 from './ec2';
import ebs from './ebs';
import elb from './elb';
import efs from './efs';

export default [...common, ...ec2, ...efs, ...elb, ...ebs, ...s3];
